__turbopack_context__.v({
  "container": "OfficeShowcaseSection-module-scss-module__zUIcNq__container",
  "contentWrapper": "OfficeShowcaseSection-module-scss-module__zUIcNq__contentWrapper",
  "galleryImage": "OfficeShowcaseSection-module-scss-module__zUIcNq__galleryImage",
  "galleryItem": "OfficeShowcaseSection-module-scss-module__zUIcNq__galleryItem",
  "galleryItem1": "OfficeShowcaseSection-module-scss-module__zUIcNq__galleryItem1",
  "galleryItem2": "OfficeShowcaseSection-module-scss-module__zUIcNq__galleryItem2",
  "galleryItem3": "OfficeShowcaseSection-module-scss-module__zUIcNq__galleryItem3",
  "galleryItem4": "OfficeShowcaseSection-module-scss-module__zUIcNq__galleryItem4",
  "heroImage": "OfficeShowcaseSection-module-scss-module__zUIcNq__heroImage",
  "heroImageWrapper": "OfficeShowcaseSection-module-scss-module__zUIcNq__heroImageWrapper",
});
